import React, { forwardRef, useEffect, useState } from "react";
import "./style.css";
import ConunterPartyGrid from "./Grid";
import { getCptyTextField, isServiceHealthy } from "../../utils/API";
import RefreshIcon from "@mui/icons-material/Refresh";
import SearchIcon from "@mui/icons-material/Search";
import withRefreshCpty from "../../redux/HOC/withRefreshCpty";
import { mapRowId } from "../../common/commonFunctions";
import { useNavigate } from "react-router";
import _ from "lodash";
import { exportMultipleSheetsAsExcel } from "ag-grid-enterprise";
import { Card, CardContent, Snackbar } from "@mui/material";
import excel from "../../assets/images/excel.svg";
import { serviceAPIMapping } from "../../config/service-api-mapping";
import { constants, EndPoint, messages } from "../../common/constants";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

const CounterParty = ({ setRefreshCpty, refreshCpty }: any) => {
  const [cptyRowData, setCptyRowData] = useState<any>();
  const [heightAG_1] = useState(75);
  const [refData, setRefData] = useState<any>(null);
  const [gridApiCpty, setGridApiCpty] = useState<any>(null);
  const navigate = useNavigate();
  const [snackbarMessage, setSnackbarMessage] = useState<any>("");
  const [open, setOpen] = useState(false);

  const cptyDataApi = async () => {
    let getCptyRes: any = "";
    try {
      getCptyRes = await getCptyTextField();
      if (getCptyRes.status === 200) {
        const cptydataApi = await getCptyRes.json();
        setCptyRowData([...mapRowId([...cptydataApi])]);
      } else if (getCptyRes.status === 401) {
        navigate("/signin");
      }
    } catch (err) {
      setCptyRowData([]);
    }
  };

  useEffect(() => {
    getServiceHealthCheck();
  }, []);

  const refreshGrid = () => {
    cptyDataApi();
    let CurrentDateforRefresh: any = new Date();
    setRefreshCpty(
      CurrentDateforRefresh.toLocaleString("en-US", {
        hour12: false,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
      })
    );
  };

  const onRefreshGrid = () => {
    setCptyRowData([]);
    refreshGrid();
  };

  const onFilterTextChange = _.debounce((e: any) => {
    gridApiCpty?.setQuickFilter(e.target.value);
  }, 800);

  function onExcelExport() {
    var spreadsheets = [];
    spreadsheets.push(
      refData?.current?.api?.getSheetDataForExcel?.({
        sheetName: "cpty",
      })!
    );

    exportMultipleSheetsAsExcel({
      data: spreadsheets,
      fileName: "cpty.xlsx",
    });
  }

  const getCardHeight = () => {
    const offsetHeight =
      document?.getElementById("secmaster-title")?.offsetHeight;
    const divHeight = _.isUndefined(offsetHeight) ? 22 : offsetHeight + 12;

    return "calc(100% - " + divHeight + "px)";
  };

  const getServiceHealthCheck = async () => {
    await isServiceHealthy(
      `${serviceAPIMapping["COUNTERPARTY-SERVICE"].apiRouteURL}/${EndPoint.actuator}`
    ).then((response: any) => {
      if (!response?.ok || response?.status === 503) {
        setSnackbarMessage(`Counter Party${messages.serviceDownMessage}`);
        setOpen(true);
      } else {
        refreshGrid();
      }
    });
  };

  const handleClose = (
    event?: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === constants.clickaway) {
      return;
    }

    setOpen(false);
  };
  const Alert = forwardRef<HTMLDivElement, AlertProps>(function Alert(
    props,
    ref
  ) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
  });

  return (
    <>
      <div className="ps-3 mt-1" id="secmaster-title">
        CounterParty Data
      </div>
      <Card style={{ height: getCardHeight() }} className="m-1">
        <Snackbar open={open} onClose={handleClose}>
          <Alert
            onClose={handleClose}
            severity="error"
            sx={{
              width: "100%",
              backgroundColor: "orange",
              textDecorationColor: "white",
            }}
          >
            {snackbarMessage}
          </Alert>
        </Snackbar>
        <CardContent className="h-100 w-100  px-2 pt-1">
          <div className="minimizeIconforLoan">
            <div
              className="globalfiltermaindivSec mb-1"
              style={{ marginLeft: "0.3rem", marginTop: "0.2rem" }}
            >
              <input
                type="search"
                placeholder="Global search..."
                id="filter-text-box-sec"
                onInput={onFilterTextChange}
              />
              <SearchIcon style={{ fontSize: "1rem", color: "#1e355e" }} />
            </div>
            <div className="d-flex align-items-center">
              <span
                className="borrowExceldnld float-start"
                onClick={onExcelExport}
                title="Download Excel"
              >
                <img
                  src={excel}
                  alt=""
                  style={{
                    height: "1.8rem",
                    width: "1.8rem",
                    cursor: "pointer",
                  }}
                />
              </span>
              <div
                className="d-flex justify-content-end align-items-center cursor-pointer ms-0 pl-0"
                onClick={onRefreshGrid}
                title="Refresh Data"
              >
                <RefreshIcon
                  style={{
                    cursor: "pointer",
                    marginRight: "0.5rem",
                    color: "#1E355E",
                  }}
                />
                <div className="refreshsettimedateContract">
                  <div>Last updated on: </div>
                  <div>{refreshCpty}</div>
                </div>
              </div>
            </div>
          </div>
          <div id="rates-dashboard" className="h-100 pb-3">
            <ConunterPartyGrid
              rowData={cptyRowData}
              height={heightAG_1}
              type="cpty"
              getBtnRef={(gridRef: any) => {
                setRefData(gridRef);
              }}
              getGridApi={(gridApi: any) => {
                setGridApiCpty(gridApi);
              }}
            />
          </div>
        </CardContent>
      </Card>
    </>
  );
};

export default withRefreshCpty(CounterParty);
